// eslint-disable-next-line no-restricted-imports
import { useFlag } from "@unleash/proxy-client-react";
import type { FeatureFlagNamesToValues } from "@src/stores/featureFlags";

type UseFlagWrapper = <T extends keyof FeatureFlagNamesToValues>(name: T) => boolean;

/**
 * This wraps `@unleash/proxy-client-react`'s `useFlag` hook and adds
 * type safety to limit flag names to known ones.
 */
export const useFlagWrapper: UseFlagWrapper = name => useFlag(name);
